export default __webpack_public_path__ + "img/payweb.69dbda8b.png";